export * from './local-storage-key.constant';
export * from './locales.contant';

export const defaultPageIndex = 1;
export const defaultPageSize = 10;
export const defaultCompactPageSize = 20;

export const dateFormat = 'DD/MM/YYYY';
export const dateTimeFormat = 'HH:mm DD/MM/YYYY';
